// extracted by mini-css-extract-plugin
export var logo = "_l9-2";
export var logoWrapper = "_l9-1";
export var strip = "_l9-0";